import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface ContactSliceStateInterface {
    Synchronize: boolean;
}

const contactSliceState: ContactSliceStateInterface = {
    Synchronize: false
};

export const contactSlice = createSlice({
    name: "contact",
    initialState: contactSliceState,
    reducers: {
        setContactSynchronize: (state, action: PayloadAction<boolean>) => {
            state.Synchronize = action.payload;
        }
    }
});

export const { setContactSynchronize } = contactSlice.actions;
export const selectContact = (state: RootState) => state.contact;
export default contactSlice.reducer;
